import React, { useState } from 'react';
import { NButton, NDialog, NInput } from '@innersource-nn/novoui-react';
import useCreateFolder from '../../hooks/useCreateFolder';
import { NewDatasetStorageLocationInput } from 'types/Dataset';
import { ModalProps } from 'types/Modal';
import { validateInput } from 'components/Inputs/regexValidation';

const NewFolderModal = ({ visible, onClose }: ModalProps) => {
    const { handleSubmit, loading } = useCreateFolder();

    const [formData, setFormData] = useState<NewDatasetStorageLocationInput>({
        prefix: '',
        label: '',
    });

    return (
        <div>
            <NDialog
                isVisible={visible}
                closeDialog={() => {
                    setFormData({
                        prefix: '',
                        label: '',
                    });
                    if (onClose) onClose();
                }}
                backgroundClose
                headline="Create folder"
                size="medium"
                showDividers={false}
            >
                <div className="flex flex-col gap-16">
                    <NInput
                        label="My folder name"
                        variant="outline"
                        placeholder="Maximum 52 characters..."
                        modelValue={formData.label}
                        invalid={formData.label.length > 52}
                        assistiveText={
                            formData.label.length > 52
                                ? 'Maximum 52 characters are allowed'
                                : ''
                        }
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                label: e.target.value,
                            })
                        }
                    />
                    <NInput
                        label="S3 prefix"
                        variant="outline"
                        placeholder="Please provide the prefix without trailing slash"
                        modelValue={formData.prefix}
                        invalid={!validateInput(formData.prefix, /^(.*[^/])?$/)}
                        assistiveText={
                            validateInput(formData.prefix, /^(.*[^/])?$/)
                                ? ''
                                : 'Please provide the prefix without trailing slash'
                        }
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                prefix: e.target.value,
                            })
                        }
                    />
                    <div className="flex justify-end gap-8">
                        <NButton variant="outline" square onClick={onClose}>
                            Cancel
                        </NButton>
                        <NButton
                            variant="fill"
                            isLoading={loading}
                            square
                            className="bg-sea-blue-600"
                            onClick={() => {
                                handleSubmit(formData);
                                if (onClose) onClose();
                            }}
                        >
                            Create
                        </NButton>
                    </div>
                </div>
            </NDialog>
        </div>
    );
};
export default NewFolderModal;
